module.exports = __webpack_public_path__ + "static/img/img_cabinet.baf42b68.png";